import React from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import { Container as ContainerBase, ContentWithPaddingXl } from "components/misc/Layouts";
import translate from "../../lang/translate";

const Container = tw(ContainerBase)`my-8 lg:my-10 bg-white text-secondary-500 -mx-8 px-8`;
const HeadingContainer = tw.div``;
const Heading = tw(SectionHeading)`sm:text-3xl md:text-4xl lg:text-5xl`;
const Subheading = tw(SubheadingBase)`text-tertiary text-center text-2xl py-1`;
const StrongText = tw.span`text-secondary-400 text-center mx-auto max-w-screen-md`;



export default () => {
  return (
    <Container>
      <ContentWithPaddingXl>
        <HeadingContainer>
          <Heading>{translate('home_page.right_place')}</Heading>
        </HeadingContainer>
        <Subheading> {translate('home_page.find_place_cv')}</Subheading>
      </ContentWithPaddingXl>
    </Container>
  );
};
